import { render, staticRenderFns } from "./chetouDetail.vue?vue&type=template&id=315de665&scoped=true&"
import script from "./chetouDetail.vue?vue&type=script&lang=js&"
export * from "./chetouDetail.vue?vue&type=script&lang=js&"
import style0 from "./chetouDetail.vue?vue&type=style&index=0&id=315de665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315de665",
  null
  
)

export default component.exports